import React, { useCallback, useEffect } from 'react';

import config from 'config';

import { Script } from '@techstyle/react-marketing';

import useCognigyWebChatAction from '../../utils/useCognigyWebChatAction';
import useGenesysWebChatAction from '../../utils/useGenesysWebChatAction';

const cognigyScript = config.get('public.cognigyWebChat.script');

export const CognigyScript = function () {
  const { cognigyEnabled, cognigyHandler, getShouldResumeChat } =
    useCognigyWebChatAction();
  const { hideGenesys } = useGenesysWebChatAction();

  useEffect(() => {
    if (cognigyEnabled) {
      hideGenesys();
    }
  }, [cognigyEnabled, hideGenesys]);

  /**
   * When the Cognigy script is ready, we will check if there is an active chat session,
   * and if there is, we will automatically open the chat window again.
   */
  const handleScriptReady = useCallback(() => {
    if (getShouldResumeChat()) {
      cognigyHandler();
    }
  }, [cognigyHandler, getShouldResumeChat]);

  useEffect(() => {
    if (cognigyEnabled) {
      window.initializeCognigyWebChat = cognigyHandler;
    }
  }, [cognigyEnabled, cognigyHandler]);

  if (!cognigyEnabled) {
    return null;
  }

  // Window Event Listener needs to be removed incase one already exists
  return (
    <>
      <Script
        src={cognigyScript}
        async
        globalScriptKey="cognigy"
        skipServerRender
        charset="utf-8"
        behavior="lazyOnload"
        onReady={handleScriptReady}
      />
    </>
  );
};
